export class EndGameRankedUserState {
    constructor(color, rankedState){
        this.color = color;
        this.rankedState = rankedState;
    }
}
